export default __webpack_public_path__ + "navigation-overview-quickstart-result-1200-365fe4d37705ce28f8518e115a9088fe.webp";